import axios, { AxiosResponse } from "axios";
import get from "lodash-es/get";
import { UserOptionsResponse } from "app/api/types";
import config from "app/api/axiosConfig";

export default (token: string) =>
	axios.get(`${process.env.REACT_APP_CHAT_HOST}/Api/UserOptions`, config(token))
		.then((response: AxiosResponse) => {
			const options: UserOptionsResponse = get(response, "data", {});
			return Promise.resolve(options)
		})
